import React, { useState, useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Input, Button, Layer } from 'components'
import { showCertImportLayerState } from 'views/setting/cert/states'
import { useRecoilState } from 'recoil'
import Native from 'library/native'

const CertImport = () => {

	const App = useApp()
	const [showCertImportLayer, setShowCertImportLayer] = useRecoilState(showCertImportLayerState)
	const [num, setNum] = useState([])
	const [buttonDisabled, setButtonDisabled] = useState(true)

	const getCertNumber = () => {
		Native.execute("Cert", "getCertAuthNum", (result) => {
			const json = JSON.parse(result);

			//console.log("getCertNumber json", json);
			if (json.resultCode === "0") {
				const number = json.result
				setNum(number)
			} else {
				App.alert(`${json.resultCode}: 인증번호 생성 도중에 오류가 발생했습니다.`)
			}

		}, {})
	}

	const getCertificate = () => {
		Native.execute("Cert", "getCertificate", (res) => {
			const json = JSON.parse(res)
			let result = json.result
			if (typeof result === "string" && result.startsWith("%")) result = decodeURI(result)
			if (json.resultCode === "0") {
				App.alert("인증서 가져오기를 완료했습니다.", () => {
					setShowCertImportLayer(false)
				})
			} else {
				App.alert(result)
			}
		}, {})
	}

	useEffect(() => {
		if (num.length > 0) {
			setButtonDisabled(false)
		} else {
			setButtonDisabled(true)
		}
	}, [num])

	useEffect(() => {
		//console.log("showCertImportLayer", showCertImportLayer)
		if (showCertImportLayer) {
			//console.log("IN");
			getCertNumber()
		}
	}, [showCertImportLayer])

	return (
		<Layer show={showCertImportLayer} closeLayer={() => setShowCertImportLayer(false)}>
			<div className="page">
				<div className="flex_1 padding pt_80">
					<div className="bring-step">
						<div>
							<i className="icon icon_pc" />
							<span className="mt_5">PC</span>
						</div>
						<div>
							<i className="icon icon_mobile" />
							<span className="mt_5">스마트폰</span>
						</div>
					</div>

					<p className="guide-title mt_40">인증번호</p>
					<div className="flex-align_center mt_10">
						<Input type="text" value={num[0]} maxlength="4" className="input-center" readOnly />
						<span className="mx_10">-</span>
						<Input type="text" value={num[1]} maxlength="4" className="input-center" readOnly />
						<span className="mx_10">-</span>
						<Input type="text" value={num[2]} maxlength="4" className="input-center" readOnly />
					</div>

					<div className="bring-guide mt_40">
						<strong>인증서 가져오는 방법</strong>
						<ul>
							<li>1. PC환경에서 아래의 순서대로 진행하세요.
								<ul className="mt_5">
									<li>① www.moneey.co.kr에 접속하세요.</li>
									<li>② 공동인증서 센터에서 [인증서 복사하기]를 선택하세요.</li>
									<li>③ 사용하실 인증서를 선택하고 비밀번호를 입력하세요.</li>
									<li>④ 인증번호 입력란에 위 인증번호 12자리를 입력하세요.</li>
								</ul>
							</li>
							<li>2. 앱 화면 하단의 [인증서 가져오기] 버튼을 선택하세요.</li>
						</ul>
					</div>
				</div>
				<div className="flex-shrink_0 padding">
					<Button className="btn btn--big" disabled={buttonDisabled} onClick={getCertificate}>인증서 가져오기</Button>
				</div>
			</div>
		</Layer>
	)
}

export default CertImport